/**
 * CardanoHealthMetrics Component
 *
 * Health metrics panel for Cardano network.
 */

import { Icons } from '../Icons';
import { GenericHealthMetrics, networkConfigs } from '../common/GenericHealthMetrics';
import type { CardanoNetworkMetrics } from '../../services/blockchainHealthApi';

const ADA_COLOR = '#0033AD';

function renderCardanoMetrics(metrics: Record<string, any>) {
  const m = (metrics || {}) as CardanoNetworkMetrics;
  return (
    <>
      {/* Active Pools */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Server size={24} style={{ color: ADA_COLOR, marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: ADA_COLOR }}>
          {(m.activePools ?? 0).toLocaleString()}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Active Pools
        </div>
      </div>

      {/* Total Staked */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Lock size={24} style={{ color: '#3366FF', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#3366FF' }}>
          {m.totalStaked ?? '0'}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Total Staked
        </div>
      </div>

      {/* Staking APY */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.TrendingUp size={24} style={{ color: '#22c55e', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#22c55e' }}>
          ~{m.stakingAPY ?? 0}%
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Staking APY
        </div>
      </div>

      {/* Current Epoch */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Calendar size={24} style={{ color: '#f59e0b', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#f59e0b' }}>
          {m.currentEpoch ?? 0}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Current Epoch
        </div>
      </div>

      {/* Blocks per Epoch */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Layers size={24} style={{ color: '#8b5cf6', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#8b5cf6' }}>
          {(m.blocksPerEpoch ?? 0).toLocaleString()}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Blocks/Epoch
        </div>
      </div>
    </>
  );
}

export function CardanoHealthMetrics() {
  const config = {
    ...networkConfigs.cardano,
    renderNetworkMetrics: renderCardanoMetrics,
  };

  return <GenericHealthMetrics config={config} />;
}
